export const formatText = (text) => {
  if (!text) return '';
  
  // Replace markdown-like syntax with HTML tags
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
    .replace(/\*(.*?)\*/g, '<em>$1</em>')           // Italic
    .replace(/_(.*?)_/g, '<u>$1</u>');             // Underline
};

export const sanitizeHtml = (html) => {
  // Only allow specific HTML tags
  const allowedTags = ['strong', 'em', 'u'];
  
  return html.replace(/<[^>]*>/g, (tag) => {
    const match = tag.match(/<\/?([a-z]+)/i);
    if (match && allowedTags.includes(match[1].toLowerCase())) {
      return tag;
    }
    return '';
  });
}; 